/**
 * Finishing - Instagram
 *
 * JS pour la gestion d'Instagram
 *
 * @since       07.10.2015
 * @version     1.0.0.0
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery(document).ready(function() {
    
    /**************************************/
    /********** SLIDER INSTAGRAM **********/
    /**************************************/
    
    if ( jQuery( '.instagram-slider-wrapper' ).length > 0 ) {
        
        jQuery( function() {
            jQuery( ".instagram-slider" ).responsiveSlides();
        });
     
    //END if ( jQuery( '.instagram-slider-wrapper' ).length > 0 )
    }

//END jQuery(document).ready
});
